import type { PieceRow } from './api'
import { actionHref, pieceHref } from './links'
import type { Destination, StageKey } from './labels'

export const PAGE_SIZE = 50
export const STAGE_KEYS: StageKey[] = ['to_review', 'check_sources', 'approved', 'scheduled', 'live', 'taken_down', 'set_aside']
export const DESTINATION_KEYS: Destination[] = ['section', 'membership', 'both']

/** The ?stage= value as a stage, or null for "All". Missing/unknown = to_review. */
export function parseStage(v: string | null): StageKey | null {
  if (v === 'all') return null
  return STAGE_KEYS.includes(v as StageKey) ? (v as StageKey) : 'to_review'
}

/** ?sent=1: only pieces a writer sent to an editor. */
export const parseSent = (v: string | null): boolean => v === '1' || v === 'true'

export function parseDestination(v: string | null): Destination | null {
  return DESTINATION_KEYS.includes(v as Destination) ? (v as Destination) : null
}

/** The "All" tab count: every stage's count added up. */
export function allCount(counts: Partial<Record<StageKey, number>> | undefined): number {
  return STAGE_KEYS.reduce((n, k) => n + (counts?.[k] ?? 0), 0)
}

/** What the row's action link says and where it goes (an absolute link under the title's `path`). */
export function rowAction(row: Pick<PieceRow, 'id' | 'status' | 'stage'>, path: string): { label: string; href: string } {
  switch (row.stage) {
    case 'to_review': return { label: 'Review', href: actionHref(path, 'review', row.id) }
    case 'check_sources': return { label: 'Check sources', href: actionHref(path, 'check_sources', row.id) }
    case 'set_aside':
      return row.status === 'failed'
        ? { label: 'Try again', href: actionHref(path, 'try_again', row.id) }
        : { label: 'Open', href: pieceHref(path, row.id) }
    default: return { label: 'Open', href: pieceHref(path, row.id) }
  }
}
